import React from 'react';
import { Done, DoneAll } from '@material-ui/icons';

const iconStyle = { fontSize: '1.2em', verticalAlign: 'middle', marginLeft: '4px' };
const greyColor = '#777';
const seenColor = '#1e88e5';

// Отметките под мое съобщение: ✓ изпратено, ✓✓ сиво — получено, ✓✓ синьо — видяно.
export default ({ status }) => {
  if (!status) return null;

  if (status.state === 'seen') {
    const title = status.names.length ? `Видяно от ${status.names.join(', ')}` : 'Видяно';
    return (
      <span title={title}>
        <DoneAll style={{ ...iconStyle, color: seenColor }} />
      </span>
    );
  }

  if (status.state === 'delivered') {
    return (
      <span title="Получено">
        <DoneAll style={{ ...iconStyle, color: greyColor }} />
      </span>
    );
  }

  return (
    <span title="Изпратено">
      <Done style={{ ...iconStyle, color: greyColor }} />
    </span>
  );
};
